import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UploadArtifactVariables {
  formData: FormData;
}

export const useUploadArtifact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ formData }: UploadArtifactVariables) => {
      const token = localStorage.getItem('token');
      const apiBase = process.env.REACT_APP_API_BASE;
      const url = `${apiBase}/artifacts`;

      const fetchOptions: RequestInit = {
        headers: {
          Authorization: `Bearer ${token}`
        },
        method: 'POST',
        body: formData
      };

      const request: Response = await fetch(url, fetchOptions);
      const responseData = await request.json();

      if (request.status >= 400) {
        const response: iResponse<any> = {
          code: request.status,
          error: responseData as ResponseErrorObj
        };
        throw response;
      }

      const response: iResponse<any> = {
        data: responseData,
        code: request.status
      };

      return response;
    },
    onSuccess: () => {
      // Invalidate and refetch artifacts list
      queryClient.invalidateQueries({ queryKey: ['artifacts'] });
    }
  });
};

export default useUploadArtifact;
